import { Button, Input, InputRef, Modal, Select, Space, Spin, notification } from 'antd'
import React,{useEffect, useRef, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import CustomButton from '../../components/Buttons/Button';
import { fetchSowTagDetails, fetchSowTagValues, updateSowIdTagging } from '../../store/reducers/orderDashboardSlice';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import Table, { ColumnsType } from 'antd/es/table';
import { ColumnType, FilterConfirmProps, TablePaginationConfig } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';


interface DataType {
  key: React.Key;
  sowId: string;
  sowName: string;
  contractValue: string;
}

type DataIndex = keyof DataType; 

const SowActionModal = (props:any) => {
  const dispatch = useDispatch();
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [selectedSoWType, setSelectedSoWType] = React.useState('');
  const [selectedChildSOW, setSelectedChildSOW] = React.useState('');
  const [actionList, setActionList] = React.useState([]);
  const [childList, setChildList] = React.useState([]);
  const [rejectReason, setRejectReason] = React.useState('');
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const selectRef = useRef<any>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<DataType> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: 'SOW Id',
      width: 150,
      dataIndex: 'sowId',
      key: 'sowId',
      fixed: 'left',
      ...getColumnSearchProps('sowId'),
    },
    {
      title: 'SOW Name',
      dataIndex: 'sowName',
      key: 'sowName',
      width: 200,
      ...getColumnSearchProps('sowName'),
    },
    {
      title: 'SOW Contract Value',
      dataIndex: 'contractValue',
      key: 'contractValue',
      width:150,
      ...getColumnSearchProps('contractValue'),
      // sorter: (a:any, b:any) => a.Total_contract_value__c - b.Total_contract_value__c
    },
    {
      title: 'Action',
      fixed: 'right',
      key: 'Action',
      width: 100,
      render: (text: string, record: any) => {
        return(
          <> {selectedChildSOW===record.sowId?
            <a className='maplink' onClick={()=>DeTagSOWHandle()}>DeTag</a>:
            <a className='maplink' onClick={()=>TagSOWHandle(record)}>Tag</a>}</>
        )
      }
    },
  ];

  const TagSOWHandle = (record:any) => {
    console.log(record);
    setSelectedChildSOW(record.sowId);
  }
  const DeTagSOWHandle = () => {
    setSelectedChildSOW('');
  }
  const getLabel=(value:any)=>{
    let label = '';
    switch(value){
      case 'MASTER':
        label = 'Select Child SOW';
        break;
      case 'CHILD':
        label = 'Select Master SOW';
        break;
      case 'AMENDMENT':
        label = 'Select Parent SOW';
        break;
      case 'CRF':
        label = 'Select Parent SOW';
        break;
      case 'DUPLICATE':
        label = 'Select Original SOW';
        break;
      default:
        label = '';
        break;
    }
    return label;
  
  }

  useEffect(() => {
    if(props.visible){
      dispatch(fetchSowTagValues({sowId:props.selectedSOW.sowId})).then((res:any)=>{
        if (res.type === 'orderDashboard/fetchSowTagValues/fulfilled') {
          debugger;
              if(res.payload && res.payload.length > 0){
                setActionList(res.payload);

        } 
      }
      else{
        rejectedApiMessage(res.payload);
      }
      });
    }
    else{
      setSelectedSoWType('');
      setSelectedChildSOW('');
    }
  }, [props.visible])

  const handleChangedValue = (id:any,value: any) => {
    selectRef.current?.blur();
    if(id === 'sowType'){
      setSelectedSoWType(value);
      setSelectedChildSOW('');
      setRejectReason('');
      setChildList([]);
      setPageNo(0);
      setSearchText('');
      setSearchedColumn('');
      if(value!=="REJECT"){
        dispatch(fetchSowTagDetails({sowId:props.selectedSOW.sowId, tagName:value})).then((res:any)=>{
          if (res.type === 'orderDashboard/fetchSowTagDetails/fulfilled') {
            debugger;
                if(res.payload && res.payload.length > 0){
                  setChildList(res.payload);
  
          } 
        }
        else{
          rejectedApiMessage(res.payload);
        }
        });
      }

    }
    if(id === 'selectedChildSOW'){
      setSelectedChildSOW(value);
    }
    if(id === 'rejectReason'){
      setRejectReason(value);
    }
  }
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  const handleSubmit = () => {
    if(selectedSoWType === ''){
      rejectedApiMessage('Please select SOW Tag');
      return;
    }
    if(selectedChildSOW === '' && selectedSoWType !== "REJECT"){
      rejectedApiMessage('Please select SOW Tag Value');
      return;
    }
    if(rejectReason === '' && selectedSoWType === "REJECT"){
      rejectedApiMessage('Please provide reason for rejection');
      return;
    }
    let data = {}
    if(selectedSoWType === "REJECT"){
      data = {
        openedSowId:props.selectedSOW.sowId,
        tagType:selectedSoWType,
        rejectReason:rejectReason
      }
    }else{
      data = {
        openedSowId:props.selectedSOW.sowId,
        tagType:selectedSoWType,
        sowId:selectedChildSOW
      }
    }
    console.log(data);
    dispatch(updateSowIdTagging(data)).then((res:any)=>{
      if (res.type === 'orderDashboard/updateSowIdTagging/fulfilled') {
        notification.success({message: 'SOW Tagging',description: 'SOW Tagging has been done successfully.'}) 
        props.onSuccess();
          setSelectedSoWType('');
          setSelectedChildSOW('');
          setRejectReason('');
          setChildList([]);
          setPageNo(0);
          setSearchText('');
          setSearchedColumn('');
        }
        else{
          rejectedApiMessage(res.payload);
        }
    });
  }

  const isSubmitDisabled = () => {
    if(selectedSoWType === ''){
      return true;
    }
    if(selectedSoWType !== "REJECT" && selectedChildSOW === ''){
      return true;
    }
    if(selectedSoWType === "REJECT" && rejectReason === ''){
      return true;
    }
    return false;
  }
  
  return (
    <Modal
    title="SOW Tagging"
    open={props.visible}
    onCancel={()=>{
      setSelectedSoWType('');
      setSelectedChildSOW('');
      setRejectReason('');
      setChildList([]);
      setPageNo(0);
      setSearchText('');
      setSearchedColumn('');
      props.onCancel();
      }}
    footer={null}
    width={1000}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <Spin spinning ={orderDashboardData.loading }>
      <div>
        <p>
          <b>SOW Id:</b> {props.selectedSOW.sowId}
        </p>
      </div>

      <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
      <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
            <FloatLabel label="Select SOW Tag" value={selectedSoWType}>
            <Select
              showSearch
              allowClear={false}
              size='middle'
              ref={selectRef}
              // style={{ width: 200 }}
              style={{ width: '100%',height:58,marginRight:'10px' }}
              placeholder="Select SOW Tag"
              optionFilterProp="children"
              value={selectedSoWType}
              onSelect={(value:string)=>handleChangedValue('sowType',value)}
              
              // onFocus={onFocus}
              // onBlur={onBlur}
              // onSearch={onSearch}
              filterOption={(input:any, option:any) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={actionList.map((item:any)=>{return {label:item,value:item}})}
          >
          </Select>
                
                </FloatLabel>
        </div>

      </div>


      {selectedSoWType !== "REJECT" && selectedSoWType!=="" && (
        <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        {/* <div className='col-lg-4 col-md-4 col-sm-12 custom-fieldcolumn'>
              <FloatLabel label={getLabel(selectedSoWType)} value={selectedChildSOW}>
              <Select
                showSearch
                allowClear={false}
                size='middle'
              //   ref={selectRef}
                // style={{ width: 200 }}
                style={{ width: '500px',height:58,marginRight:'10px' }}
                placeholder={getLabel(selectedSoWType)}
                optionFilterProp="children"
                value={selectedChildSOW}
                onSelect={(value:string)=>handleChangedValue('selectedChildSOW',value)}
                
                // onFocus={onFocus}
                // onBlur={onBlur}
                // onSearch={onSearch}
                filterOption={(input:any, option:any) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={childList}
            >
            </Select>
                  
                  </FloatLabel>
          </div> */}
          <div>
            {getLabel(selectedSoWType)}
          </div>
          <Table
            className='table-style'
            columns={columns} 
            dataSource={childList} 
            // loading={orderDashboardData?.loading}
            scroll={{ x: 'max-content', y: 250}} 
            pagination={{
              current: pageNo + 1,
              pageSize,
              total: totalCount,
              showSizeChanger: false,
  
            }}
            rowKey={'sowId'}
            onChange={handleTableChange}
            ></Table>
  
        </div>
      
      )}

      {selectedSoWType === "REJECT" && (
        <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div className='col-lg-6 col-md-6 col-sm-12 custom-fieldcolumn'>
                  <FloatLabel label="Reason for Rejection *" value={rejectReason} isMultiSelect={true} reasontype="rejectReason">
                    <Input.TextArea
                      value={rejectReason}
                      id={"rejectReason"}
                      size='middle'
                      rows={4}

                      style={{ width: '820px', marginRight: '10px',paddingTop:'20px', resize:'none',color:"black" }}
                      onChange={(e) => handleChangedValue('rejectReason', e.target.value)}
                    />
                    
                  </FloatLabel>
          </div>
  
        </div>
      
      )}


      <div className='row' style={{ display: 'flex', flexWrap: 'wrap', justifyContent:'end' }}>
        
        <CustomButton label="Cancel" type="cancel" onClick={()=>{
          setSelectedSoWType('');
          setSelectedChildSOW('');
          setRejectReason('');
          setChildList([]);
          setPageNo(0);
          setSearchText('');
          setSearchedColumn('');
          props.onCancel();
          }} />
        <CustomButton
              label="Submit"
              type="submit"
              disabled={isSubmitDisabled()}
              onClick={() =>{handleSubmit()}}
            />
      </div>
    </Spin>
  </Modal>
  )
}
export default SowActionModal;
